<template>
  <div class lang="tr">
    <form id="step4" @submit="sendForm">
      <template v-if="!isChannelKollektifHouse">
        <h3 class="main_question"><strong>2/3</strong>{{ $t('Faaliyet Adres Bilgisi') }}</h3>
        <div class="form-group">
          <label class="container_radio version_2" @click="form.virtual_office = false">
            {{ $t('Faaliyet adresim var') }}
            <input
              v-model="form.office_status"
              class="required"
              name="question_rent_owner"
              type="radio"
              value="owned"
            />
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="form-group">
          <label
            class="container_radio version_2"
            data-target="#coworking-modal"
            data-toggle="modal"
            @click="form.virtual_office = true"
          >
            {{ $t('Mükellefin sanal ofis hizmetinden faydalanmak istiyorum') }}
            <input
              v-model="form.office_status"
              class="required"
              name="question_rent_owner"
              type="radio"
              value="virtual"
            />
            <span class="checkmark"></span>
          </label>
        </div>
        <transition name="fade">
          <div v-if="form.office_status == 'virtual'" id="rent-information">
            <h3 class="main_question">{{ $t('Yasal Adres') }}</h3>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="container_check version_2">
                    {{ $t('Yasal adres hizmeti almak istiyorum') }}

                    <template v-if="virtualOffice.net_price === 0">
                      <b class="free-text ml-1">{{ $t('Ücretsiz') }} </b>
                    </template>
                    <template v-else>
                      [{{
                        formatPrice(
                          Number((virtualOffice.net_price * 100) / (100 + Number(virtualOffice.vat_rate))),
                          virtualOffice.currency
                        )
                      }}+KDV
                      {{
                        virtualOffice.type === 'subscription'
                          ? virtualOffice.period === 'annual'
                            ? '/ ' + $t('Yıl')
                            : '/ ' + $t('Ay')
                          : ''
                      }}]
                    </template>

                    <input v-model="form.virtual_office" :value="true" name="coworking-service[]" type="radio" />
                    <span class="checkmark"></span>
                  </label>
                  <div v-if="form.virtual_office" class="row">
                    <div v-for="virtualOffice in virtualOffices" :key="virtualOffice.slug" class="col-4">
                      <div class="form-group">
                        <label class="container_radio version_2">
                          {{ virtualOffice.name }}
                          <input
                            v-model="form.virtual_office_region"
                            class="required"
                            name="virtual_office_region"
                            type="radio"
                            :value="virtualOffice.slug"
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div v-if="form.office_status == 'owned'" id="virtual-information">
            <h3 class="main_question">{{ $t('Faaliyet Adresi') }}</h3>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="addrescityinput">İl</label>
                  <v-select
                    v-model="billingCity"
                    :options="cities"
                    label="name"
                    placeholder="İl"
                    name="address-city"
                    :class="{ 'is-invalid': errors.first('address-city') }"
                    v-validate="'required'"
                  />
                  <span v-show="errors.first('address-city')" class="show-invalid invalid-feedback">{{
                    errors.first('address-city')
                  }}</span>
                  <error-box field="billing_address.city_id" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="addesscountyinput">İlçe</label>
                  <v-select
                    v-model="billingDistrict"
                    :options="districts"
                    label="name"
                    placeholder="İlçe"
                    :class="{ 'is-invalid': errors.first('address-district') }"
                    name="address-district"
                    v-validate="'required'"
                  />
                </div>
                <span v-show="errors.first('address-district')" class="show-invalid invalid-feedback">{{
                  errors.first('address-district')
                }}</span>
                <error-box field="billing_address.district_id" />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="billing_address">Açık Address</label>
                  <textarea
                    id="billling_address"
                    v-model="form.billing_address.address"
                    class="form-control"
                    name="billling_address"
                    placeholder="Açık Adres"
                    rows="3"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.first('billling_address') }"
                  />
                  <span v-show="errors.first('billling_address')" class="show-invalid invalid-feedback">{{
                    errors.first('billling_address')
                  }}</span>
                  <error-box field="billing_address.address" />
                </div>
              </div>
            </div>
          </div>
        </transition>

        <template v-if="form.virtual_office">
          <h3 class="main_question">{{ $t('Vekalet Hizmeti') }}</h3>
          <div class="ml-2 mb-3">
            <label class="container_check version_2">
              {{ $t('Vekalet hizmeti almak istiyorum') }}
              <input v-model="proxy_service" :value="true" name="proxy-service" type="checkbox" />
              <span class="checkmark"></span>
            </label>
          </div>

          <div class="mb-3">
            <a
              id="proxyService"
              data-target="#proxy-service-modal"
              data-toggle="modal"
              href="#"
              class="btn-outline-mukellef btn-radius"
            >
              <i class="fa fa-play link-button-icon"></i><span>{{ $t('Vekalet Hizmetini Neden Almalıyım?') }}</span>
            </a>
          </div>
        </template>
      </template>
      <h3 class="main_question">{{ $t('İşletme Bilgileri') }}</h3>
      <div class="form-group">
        <date-picker
          v-model="form.establish_at"
          name="establish_at"
          v-tippy="$t('Mükellef olmak istediğiniz tarihi gün ay ve yıl sırasıyla giriniz')"
          class="w-100 mb-1"
          :class="errors.first('establish_at') ? 'is-invalid' : 'is-valid'"
          input-class="date-picker"
          :popup-style="{ top: '100%', left: 0 }"
          :append-to-body="false"
          format="DD/MM/YYYY"
          valueType="format"
          :lang="$i18n.locale"
          v-validate="'required|date_format:dd/MM/yyyy'"
          :error="errors.first('establish_at')"
          :placeholder="$t('Mükellef olmak istediğiniz tarih gg aa yyyy')"
        ></date-picker>
        <error-box field="establish_at" />
      </div>
      <div class="form-group">
        <a
          id="whyAskingTcModal"
          data-target="#establish-date-description"
          data-toggle="modal"
          href="#"
          class="btn-outline-mukellef btn-radius"
        >
          <i class="fa fa-play link-button-icon"></i><span>{{ $t('Mükellef Olma Tarihi Neden Önemli') }}</span>
        </a>
      </div>

      <!-- End Faaliyet Bilgileri -->
      <h3 class="main_question">
        Kosgeb Destekleri
        <span v-tippy="kosgebTooltip"><i class="fa fa-question-circle" /></span>
      </h3>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label :class="{ 'is-invalid': errors.first('kosgeb') }" class="container_check version_1">
              {{ $t('Evet şartları sağlıyorum Mükellef Ekibi beni arayabilir') }}
              <input
                name="kosgeb"
                type="radio"
                value="true"
                @click="form.kosgeb = true"
                :checked="form.kosgeb === true"
                v-validate="'required'"
                :error="errors.first('kosgeb')"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label :class="{ 'is-invalid': errors.first('kosgeb') }" class="container_check version_1">
              {{ $t('Hayır destek için şartları sağlamadığım için aranmak istemiyorum') }}
              <input
                name="kosgeb"
                type="radio"
                value="1"
                @click="form.kosgeb = false"
                :checked="form.kosgeb === false"
                :error="errors.first('kosgeb')"
              />
              <span class="checkmark"></span>
            </label>
            <div v-show="errors.has('kosgeb')" class="invalid-feedback-errorbox">
              {{ errors.first('kosgeb') }}
            </div>
          </div>
        </div>
      </div>
      <div class="form-group mt-1 mb-4">
        <a
          id="mukellefKosgebModal"
          data-target="#kosgeb-modal"
          data-toggle="modal"
          href="#"
          class="btn-outline-mukellef btn-radius"
        >
          <i class="fa fa-play link-button-icon"></i><span>{{ $t('Mükellef ile KOSGEB süreci nasıl işliyor') }}</span>
        </a>
      </div>
      <!-- Begin İşletme Bilgileri -->
    </form>
    <CoworkingModal />
    <KosgebModal />
    <ProxyServiceModal />
  </div>
</template>
<script>
/* eslint-disable camelcase */

import CoworkingModal from '../../../CoworkingModal';
import KosgebModal from '../../../modals/videos/KosgebModal';
import ProductStore from '../../../../stores/product';
import RegisterStore from '@/stores/register';
import ProxyServiceModal from '../../../modals/videos/ProxyServiceModal';
import VirtualOfficeStore from '../../../../stores/virtual-office';

export default {
  data() {
    return {
      form: {
        coworking: true,
        employee_count: '',
        virtual_office: false,
        virtual_office_region: 'kadikoy',
        kosgeb: null,
        companyType: {
          data: {},
        },
        address: null,
      },
      cities: [],
      districts: [],
      virtualOffice: {},
      virtualOffices: [],
      virtual: true,
      companyId: null,

      kosgebTooltip: this.$t('Register Step 3 kosgebTooltip'),
      proxy_service: false,
      defaultOfficeStatus: 'virtual',
    };
  },
  computed: {
    isChannelKollektifHouse() {
      if (this.form.id && this.form.users.data[0].channel.data.slug === 'kolektifhouse') {
        return true;
      }
      return false;
    },
    billingCity: {
      get() {
        if (this.form.billing_address.city_id) {
          return {
            name: this.form.billing_address.city_readable,
            id: this.form.billing_address.city_id,
          };
        } else {
          return null;
        }
      },
      set(val) {
        this.form.billing_address.city_id = val ? val.id : null;
        this.form.billing_address.city_readable = val ? val.name : null;
        this.billingDistrict = null;
        this.getDistricts(val.id);
      },
    },
    billingDistrict: {
      get() {
        if (this.form.billing_address.district_id) {
          return {
            name: this.form.billing_address.district_readable,
            id: this.form.billing_address.district_id,
          };
        }
        return null;
      },
      set(val) {
        this.form.billing_address.district_id = val ? val.id : null;
        this.form.billing_address.district_readable = val ? val.name : null;
      },
    },
  },
  created() {
    this.startWaiting();
    this.companyId = this.$store.state.companyId;

    $axios.get('company?include=users.channel').then((s) => {
      if (s.data.data.length === 1) {
        this.form = s.data.data[0];
        this.form.employee_count = '0';
        this.form.employee_count_readable = 'Hayır';
        if (!this.form.establish_at) {
          this.form.establish_at = new Date().toLocaleDateString('en-GB');
        }
        if (this.form.office_status !== 'owned' && this.form.office_status !== 'virtual') {
          this.form.office_status = this.defaultOfficeStatus;
          this.form.virtual_office = true;
        }
        this.companyId = s.data.data[0].id;
        this.form.kosgeb = s.data.data[0].kosgeb;
        this.proxy_service = s.data.data[0].package != null ? s.data.data[0].package.includes('VKLT') : false;
        this.companyTypeId = s.data.data[0].company_type_id;

        this.getVirtualOffices(s.data.data[0].company_nation_id);

        $axios.get('city').then((s) => {
          this.cities = s.data.data;
        });

        if (this.form.billing_address.city_id) {
          this.getDistricts(this.form.billing_address.city_id);
        }

        if (!this.isChannelKollektifHouse) {
          if (
            this.form.package.includes('ADVANCE_TRPACKAGE') ||
            this.form.package.includes('ADVANCE_TRPACKAGEANNUAL')
          ) {
            this.endWaiting();
            this.virtualOffice = {
              currency: null,
              net_price: 0,
            };
          } else {
            const code = [];
            if (this.form.period === 'monthly') {
              code.push('VIRTUALOFFICESER');
            } else {
              code.push('VIRTUALOFFICESERANNUAL');
            }

            ProductStore.dispatch('getProductsByCodes', {
              codes: code,
              sort: true,
              companyTypeId: this.companyTypeId,
            }).then((s) => {
              this.endWaiting();
              this.virtualOffice = s.data.data[0];
            });
          }
        } else {
          this.endWaiting();
        }
      }
    });
  },
  methods: {
    isCorporate() {
      if (this.form.companyType.data.code) {
        if (['LIMITED', 'CORPORATION'].indexOf(this.form.companyType.data.code) > -1) {
          return true;
        }
      }
      return false;
    },
    updateCompany(form) {
      return $axios.put('register/' + this.companyId + '/company', form);
    },
    updatePackage(form) {
      return RegisterStore.dispatch('package', { packages: form.package, companyNationId: 1 });
    },
    getDistricts(cityId) {
      if (cityId) {
        $axios.get('district?city_id=' + cityId).then((s) => {
          this.districts = s.data.data;
        });
      }
    },
    vselectFilter(option, label, search) {
      return (label.turkishToLower() || '').indexOf(search.turkishToLower()) > -1;
    },
    getVirtualOffices(companyNationId) {
      VirtualOfficeStore.dispatch('getVirtualOffices', companyNationId).then((s) => {
        this.virtualOffices = s.data.data;

        this.form.virtual_office_region =
          this.form.virtual_office_region && this.virtualOffices.find((x) => x.slug === this.form.virtual_office_region)
            ? this.form.virtual_office_region
            : 'kadikoy';
      });
    },
    sendForm(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const form = this.form;
          form.country_id = 1;

          if (this.proxy_service === true && this.form.virtual_office === true) {
            form.proxy_service = this.proxy_service;
          }

          this.startWaiting();

          const index = this.form.package.indexOf('VIRTUALOFFICESER');
          const index2 = this.form.package.indexOf('VIRTUALOFFICEST');
          const index3 = this.form.package.indexOf('VIRTUALOFFICESERANNUAL');
          const vkltIndex = this.form.package.indexOf('VKLT');
          if (this.isChannelKollektifHouse) {
            form.office_status = 'kolektif';
            form.proxy_service = false;
            form.virtual_office = false;
          }

          if (form.office_status === 'virtual') {
            if (this.virtualOffice.net_price !== 0) {
              if (form.period === 'monthly' && index === -1) {
                form.package.push('VIRTUALOFFICESER');
              } else if (form.period === 'annual' && index3 === -1) {
                form.package.push('VIRTUALOFFICESERANNUAL');
              }
            }
            if (index2 === -1 && this.virtualOffice.net_price !== 0) {
              form.package.push('VIRTUALOFFICEST');
            }
            form.billing_address = null;
          } else {
            const valuesToRemove = ['VIRTUALOFFICESER', 'VIRTUALOFFICEST', 'VIRTUALOFFICESERANNUAL'];
            form.package = form.package.filter((i) => !valuesToRemove.includes(i));
          }

          if (form.proxy_service) {
            if (vkltIndex === -1) {
              form.package.push('VKLT');
            }
          } else {
            const valuesToRemove = ['VKLT'];
            form.package = form.package.filter((i) => !valuesToRemove.includes(i));
          }

          $axios.all([this.updateCompany(form), this.updatePackage(form)]).then(
            $axios.spread((first_response, second_response) => {
              this.endWaiting();
              this.$toasted.show(this.$t('AlertMessages.Bilgileriniz kaydedildi'));
              // eslint-disable-next-line node/no-callback-literal
              callback(true);
            })
          );
        }
      });
    },
  },
  components: { CoworkingModal, KosgebModal, ProxyServiceModal },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.font-12 * {
  font-size: 12px;
}
</style>
